import React from 'react';
import { MEMBER_LIST } from '../../../../../common/constants/data-hooks';
import OwnerInfo from './owner-info';
import { getCurrentMember, getReactionOwnerId, } from '../../../../../common/store/members/members-selectors';
import { useApi } from '../../../../context/api-context/use-api';
import FollowButton from './follow-button/follow-button';
import classNames from 'classnames';
import styles from './member-list.scss';
export const sortGuestsAsLast = (ownerList) => {
    return [
        ...ownerList.filter((owner) => owner.type !== 'ANONYMOUS'),
        ...ownerList.filter((owner) => owner.type === 'ANONYMOUS'),
    ];
};
export const MemberList = ({ memberList, className, mainReactionName, showReaction = false, showAvatars = true }) => {
    const currentMember = useApi(getCurrentMember);
    return (React.createElement("div", { className: classNames(styles.memberList, className), "data-hook": MEMBER_LIST }, sortGuestsAsLast(memberList).map((owner) => (React.createElement("div", { className: classNames(styles.memberRow, { [styles.withoutAvatars]: !showAvatars }), key: getReactionOwnerId(owner) },
        React.createElement(OwnerInfo, { owner: owner, showReaction: showReaction, showAvatars: showAvatars, mainReactionName: mainReactionName }),
        owner.type === 'MEMBER' &&
            currentMember?.id !== owner.member.id &&
            owner.member.profile.nickname ? (React.createElement(FollowButton, { memberId: owner.member.id, name: owner.member.profile.nickname })) : null)))));
};
//# sourceMappingURL=member-list.js.map